<script>
  import IntersectionObserver from "svelte-intersection-observer";
  import Dropzones from "./Dropzones.svelte";
  import Emoji from "@helpers/Emoji.svelte";

  let element;
  export let intersecting = false;
</script>

<IntersectionObserver {element} bind:intersecting>
  <section bind:this={element} id="build">
    <div class="prose">
      <h1 class="section-title">
        What if you could <span class="accent-text">
          control the <span class=" emoji-follows" data-emoji="😮"
            >budget?<Emoji emoji="wow" />
          </span>
        </span>
      </h1>
      <p class="body-text">
        One way to talk about what we want the budget to fund is through
        services.
        <!-- When designing a budget, the first thing to consider is what your
        priorities are. -->
        Presented below are departments funded by the
        <span class="with-tooltip"
          ><span class="tooltip text"
            >The General Fund is a $2.8 billion operating budget which supports
            a majority of city functions—including most of the departments
            you've heard of.</span
          >General Fund.</span
        >
      </p>
      <p class="body-text">
        What's most important to you? Some things to consider are:
      </p>
      <ul class="body-list">
        <li>Which services do you use the most?</li>
        <li>Which services do you wish were better or more accessible?</li>
      </ul>
      <p class="direction-text">
        Click to select the four departments that are most important to you!
      </p>
    </div>
    <Dropzones />
  </section>
</IntersectionObserver>

<style>
  section {
    text-align: left;
    padding: 5rem 1rem;
    /* margin: 0 auto 5rem auto; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    place-items: center;
    /* min-height: 100vh; */
    /* background: rgb(245, 166, 35); */
    border: 1px solid rgba(var(--text-color-rgb), 0.25);
  }

  .emoji-follows::before {
    top: -1rem;
    right: -5rem;
  }
</style>
